// @core/api/endpoints/notifications/list_notifications_scheduled.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNotificationsScheduledResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List scheduled notifications
 * Returns a paginated list of all scheduled notifications. Supports filtering by date range and status to view pending or completed schedules.
 */
export async function ListNotificationsScheduled(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNotificationsScheduledResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/notifications/scheduled`;
  const requestOptions = options;
  return client.get<ListNotificationsScheduledResponse>(requestPath, { ...requestOptions, params });
}
